import React from 'react';
import '../CustomJewelryPage/Styles.css'
import ContactSection from '../../components/ContactSectionPage/Index';
import useTitle from '../../useTitle';

const CustomJewelry = () => {
    useTitle("Custom Jewelry");
  return (
    <>
    <div className='customJewelrySection'>

        <div className='customJewelryDescription'>
            <div className='customJewelryDescriptionTitleSection'>
                <h1 className='customJewelryDescriptionTitle'>Custom Jewelry</h1>
            </div>
            <div className='customJewelryDescriptionText'>
                <p>I would love to accompany you in creating a beautiful, timeless jewel.</p>
            </div>
        </div>

        <div className='customJewelrySteps'>
            <div className='steps'>
                <div className='stepCircle'>
                    <h1>1</h1>
                </div>
                <div className='stepTitle'>
                    <h1>Consultation</h1>
                </div>
                <div className='stepDescription'>
                    <p>We discuss your vision, materials and sketch ideas together.</p>
                </div>
            </div>

            <div className='steps'>
                <div className='stepCircle'>
                    <h1>2</h1>
                </div>
                <div className='stepTitle'>
                    <h1>Crafting</h1>
                </div>
                <div className='stepDescription'>
                    <p>The jewel is completely handcrafted with every attention to detail.</p>
                </div>
            </div>

            <div className='steps'>
                <div className='stepCircle'>
                    <h1>3</h1>
                </div>
                <div className='stepTitle'>
                    <h1>Reveal</h1>
                </div>
                <div className='stepDescription'>
                    <p>I present you the finished jewel.</p>
                </div>
            </div>
        </div>

        <div className='customJourneyButtonContainer'>
            <button onClick={() => window.location.href = "/contact"} className='customJourneyButton'>Book an Appointment</button>
        </div>

    </div>
    <ContactSection />
    </>
  )
}

export default CustomJewelry;
